import { useApiQuery } from '@/modules/common';
import { PrinterType } from '@/modules/common/types';
import { useModelAttributes } from '@/modules/models';

const emptyModelOptions = {
  colors: [],
  types: [],
  genders: [],
  fileNames: [],
};

export function useGcrFormOptions() {
  const { data: optionsData } = useModelAttributes();

  const { data: printers, isFetching: isFetchingPrinters } = useApiQuery<
    PrinterType[]
  >('/printers', {
    queryKey: ['eventPrinters'],
    initialData: [],
  });

  return {
    isFetchingPrinters,
    printers,
    optionsData: {
      ...emptyModelOptions,
      ...optionsData,
      printers,
    },
  } as const;
}
